import React from "react";

import { useTranslation } from "react-i18next";

import defaultAvatar from "../../resources/default_avatar.png";

import type { JSX } from "react";

function DefaultAvatarImage(): JSX.Element {
  const { t } = useTranslation("editor-utils");

  return (
    <img
      alt={t("defaultAvatar")}
      className="size-full rounded-full object-cover"
      src={defaultAvatar}
    />
  );
}

export default DefaultAvatarImage;
